import React from 'react';

interface RedAlertProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const RedAlert: React.FC<RedAlertProps> = (props) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.80385 4.75264C12.3397 3.25088 13.6077 2.5 15 2.5C16.3923 2.5 17.6603 3.25088 20.1962 4.75264L21.0538 5.26057C23.5897 6.76233 24.8577 7.51321 25.5538 8.75C26.25 9.98679 26.25 11.4885 26.25 14.4921V15.5079C26.25 18.5115 26.25 20.0132 25.5538 21.25C24.8577 22.4868 23.5897 23.2377 21.0538 24.7394L20.1962 25.2474C17.6603 26.7491 16.3923 27.5 15 27.5C13.6077 27.5 12.3397 26.7491 9.80385 25.2474L8.94615 24.7394C6.41025 23.2377 5.1423 22.4868 4.44615 21.25C3.75 20.0132 3.75 18.5115 3.75 15.5079V14.4921C3.75 11.4885 3.75 9.98679 4.44615 8.75C5.1423 7.51321 6.41025 6.76233 8.94615 5.26057L9.80385 4.75264ZM16.25 20C16.25 20.6904 15.6904 21.25 15 21.25C14.3096 21.25 13.75 20.6904 13.75 20C13.75 19.3096 14.3096 18.75 15 18.75C15.6904 18.75 16.25 19.3096 16.25 20ZM15 7.8125C15.5178 7.8125 15.9375 8.23223 15.9375 8.75V16.25C15.9375 16.7678 15.5178 17.1875 15 17.1875C14.4822 17.1875 14.0625 16.7678 14.0625 16.25V8.75C14.0625 8.23223 14.4822 7.8125 15 7.8125Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default RedAlert;
